module.exports = __webpack_public_path__ + "static/media/ios-4.7132580b.jpg";